import useSWR, { type SWRResponse } from 'swr'

import {
  type Brand,
  SellerCentralControllerV2ApiFactory,
} from '@redteclab/api/clients/bully'

import { useGlooApi } from '../../../api'
import { useGlobalConfigContext } from '../../../global-config'

type UseMarketplacePartnerRegisterPageSearchBrandsParams = {
  max?: number
  q?: string
}

const BRANDS_LIMIT = 200

const getMarketplacePartnerRegisterPageFormApiSearchBrandsKey = ({
  language,
  max,
  q: query,
  tenant,
}: {
  language: string
  max?: number
  q?: string
  tenant: string
}): string[] => {
  return [
    'marketplacePartnerRegisterPageSearchBrands',
    tenant,
    language,
    query ?? '',
    String(max ?? BRANDS_LIMIT),
  ]
}

export const useMarketplacePartnerRegisterPageFormApiSearchBrands = (
  params?: UseMarketplacePartnerRegisterPageSearchBrandsParams,
): SWRResponse<Brand[]> => {
  const config = useGlobalConfigContext()
  const client = useGlooApi(SellerCentralControllerV2ApiFactory)

  const { max = BRANDS_LIMIT, q: query } = params ?? {}

  const fetcher = async (): Promise<Brand[]> => {
    const response = await client.searchBrands({
      language: config.language,
      max,
      // eslint-disable-next-line id-length -- name of the query param
      q: query ?? '',
      tenant: config.tenantAndEnv,
    })

    return response.data
  }

  return useSWR(
    getMarketplacePartnerRegisterPageFormApiSearchBrandsKey({
      language: config.language,
      max,
      // eslint-disable-next-line id-length -- name of the query param
      q: query,
      tenant: config.tenantAndEnv,
    }),
    fetcher,
  )
}
